<app-toolbar></app-toolbar>
<div fxLayout="row">
  <div class="actionsContainer">
    <div class="button">
      <button mat-raised-button color="accent" (click)="createNewUser()"> Ajouter un utilisateur </button>
    </div>
    <div class="input">
      <mat-form-field class="example-form-field" appearance="fill">
        <mat-label>Nom d'utilisateur</mat-label>
        <input [formControl]="userNameControl" name="userName" matInput type="text" [(ngModel)]="filterValue" (input)="filterUsers(filterValue)" placeholder="Find user by name">
        <button *ngIf="filterValue" matSuffix mat-icon-button aria-label="Clear" (click)="filterValue=''">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>


    </div>
  </div>
</div>
<div fxLayout="row wrap">
  <cdk-virtual-scroll-viewport appendOnly itemSize="60" class="example-viewport">
    <div class="card-container" *cdkVirtualFor="let user of filteredUser">

      <app-user-card [user]="user" [groups]="groups" [devices]="devices" [licences]="user.licence"></app-user-card>
    </div>
  </cdk-virtual-scroll-viewport>
</div>
